import { type z } from "zod"
import { type MarketNameSchema } from "@/schemas/marketName"

export type MarketName = z.infer<typeof MarketNameSchema>

export const MarketName = {
    FRA_ELECTRICITY: "FRA_ELECTRICITY",
    FRA_GAS: "FRA_GAS",
} as const satisfies Record<MarketName, MarketName>
